'use client';

import { useBuyContext } from '../../state/BuyContext';
import { useBuySelection } from '../../state/useBuySelection';
import { resolve, type ActionCardConfig } from '../../state/cardSchema';
import { Section } from '../Section';
import styles from './ActionCard.module.css';

export type ActionCardProps = {
  card: ActionCardConfig;
};

export const ActionCard = ({ card }: ActionCardProps) => {
  const { resolveCtx } = useBuyContext();
  const { selected, select } = useBuySelection(card.id);

  // The "decline" id is reserved for the active state when the user opted out.
  const declineId = card.declineOption?.id ?? '__decline__';
  const isDeclined = selected === declineId;
  const isActiveSelection = selected != null && selected !== declineId;

  return (
    <Section id={card.id} title={card.title} subtitle={card.subtitle} info={card.info}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.primaryButton}
          data-active={isActiveSelection ? 'true' : 'false'}
          onClick={() => card.open(resolveCtx)}
          aria-pressed={isActiveSelection}
        >
          {isActiveSelection && card.activeRender
            ? card.activeRender(resolveCtx)
            : card.idleLabel}
        </button>

        {card.declineOption ? (
          <button
            type="button"
            className={styles.declineButton}
            data-active={isDeclined ? 'true' : 'false'}
            onClick={() => select(declineId)}
            aria-pressed={isDeclined}
            disabled={!!resolve(card.declineOption.disabled, resolveCtx)}
          >
            {card.declineOption.label}
          </button>
        ) : null}
      </div>
    </Section>
  );
};
